import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  span {
    text-align: center;
    font-size: 1.5rem;
    padding: 25px 30px 0 30px;
  }
`;

export { Container };
